import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Box, Button, Flex, HStack, Input, InputGroup, InputRightElement, Portal, Table, TableContainer, Tbody, Td, Text, Thead, Tr, useToast } from '@chakra-ui/react';

import { ChangeEvent, useEffect, useRef, useState } from 'react';
import { BsCheckLg } from 'react-icons/bs';
import { FaTimes } from 'react-icons/fa';
import { RiSearch2Line } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import AdminDashboardHeader from '../../../components/admin/AdminHeader';
import AdminSidebar from '../../../components/admin/AdminSidebar';
import { CreateBadgeModal } from '../../../components/admin/badges/CreateBadgeModal';
import { IAssignedBadgesList, IAssignedBadgesRes } from '../../../models/admin/badges/assignedBadgeModel';
import BadgeService from '../../../services/admin/badge.service';




const AssignedBadges = () => {
    const navigate = useNavigate();
    const toast = useToast()
    const [search, setSearch] = useState("");
    const [query, setQuery] = useState("");
    const [badgeList, setbadgeList] = useState<IAssignedBadgesList[]>([]);
    const [fileteredBadges, setFilteredBadges] = useState<IAssignedBadgesList[]>([]);

    const [isLoading, setIsLoading] = useState(true);
    const [reload, setReload] = useState(false);
    const [parameterName, setParameterName] = useState<string>();
    const [isEditbadge, setisEditbadge] = useState(false);
    const [isbadge, setisbadge] = useState(false);
    const [badge, setbadge] = useState<any>();
    const [badgeName, setbadgeName] = useState<string>();

    const cancelRef = useRef(null);
    const [isOpenAlert, setIsOpenAlert] = useState(false);
    const onCloseAlert = () => setIsOpenAlert(false);
    useEffect(() => {

        BadgeService.getRecievedBadges()
            .then((data) => {
                const system_badge: IAssignedBadgesRes = data
                setbadgeList(system_badge.data.data);
                setFilteredBadges(system_badge.data.data);
                setIsLoading(false)
            })
            .catch((err) => err)

    }, [query, reload]);




    const reloadData = () => {
        setReload(!reload);
    };
    const openRevokeBadge = (param: string) => {
        setParameterName(param)
        setisEditbadge(false)
        setisbadge(false)
        setIsOpenAlert(true)
    };
    const revokeBadge = async () => {
        try {
            const delete_param: any = await BadgeService.revokeBadge(parameterName)
            if (delete_param.status == 'success') {
                toast({
                    title: "Revoke Badge",
                    description: "Badge revoked successfully",
                    status: "success",
                });
                setReload(!reload)
                onCloseAlert();

            } else {
                toast({
                    title: "Revoke Badge",
                    description: `${delete_param.error}`,
                    status: "error",
                });
            }
        } catch (error: any) {
            toast({
                title: "Revoke Badge",
                description: `${error}`,
                status: "error",
            });
        }
    }
    const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
        const searchTerm = event.target.value.toLowerCase();
        if (!searchTerm) {
            setFilteredBadges(badgeList);
        } else {
            if (badgeList) {
                const filtered = badgeList.filter((each: any) =>
                    each.receiver.name.toLowerCase().includes(searchTerm) || each.badge.name.toLowerCase().includes(searchTerm)
                );
                setFilteredBadges(filtered);

            }
        }
    };

    return (
        <>
            {
                <Flex           minHeight={"100vh"}
                height={"auto"}
                boxSizing="border-box"
                maxWidth={"100hw"}>
                        <Box
            width={["3.5rem", "3.5rem", "3.5rem", "20%"]}
            position="relative"
            top="0"
            left="0"
            zIndex="100"
          >
            <AdminSidebar />
          </Box>
                    <Box width='100%' >
                        <AdminDashboardHeader />
                        <Box        pt="30px"
              px={["20px", "30px"]}
              width={"100%"}
              bg="#F9F8F8"
              height={"auto"}
              minHeight={"95vh"}
              maxHeight={"95vh"}
              overflowX={"scroll"}
              className="scroll-hidden">
                            <Flex
                                justifyContent="space-between"
                                alignItems="baseline"
                                py="26px"
                            >
                                <Text color='#2B2B2B' fontWeight="800" fontSize='27px'>Assigned Badges</Text>

                            </Flex>
                            <Box width='100%'>
                                <Box >

                                    <Flex py='15px' justifyContent=''>
                                        <InputGroup bg="white"                width={["100%", "100%", "50%", "30%"]}>
                                            <Input height='40px' placeholder="Search input here" onChange={(e) => handleSearchChange(e)} fontSize={12} size="sm" />
                                            <InputRightElement pointerEvents="none" children={<RiSearch2Line color="red" size="0.9rem" />} />
                                        </InputGroup>

                                    </Flex>
                                    <Box width={'100%'}>
                                        <TableContainer>
                                            <Table>
                                                <Thead>
                                                    <Tr bg="white" py={'15px'} >
                                                        <Td  > Assigned To</Td>
                                                        <Td >Assigned By  </Td>
                                                        <Td >Badge</Td>
                                                        <Td >Reason</Td>
                                                        <Td >Revoked</Td>
                                                        <Td >Actions</Td>
                                                    </Tr>
                                                </Thead>
                                                <Tbody>
                                                    {
                                                        fileteredBadges && fileteredBadges.length > 0 && (
                                                            fileteredBadges.map((badge, index: number) => (
                                                                <Tr bg="white" key={index}>



                                                                    <Td>
                                                                        <Text fontSize={'13px'} >{badge.receiver.name}</Text>
                                                                    </Td>
                                                                    <Td>
                                                                        <Text fontSize={'13px'} >{badge.creator.name}</Text>
                                                                    </Td>
                                                                    <Td>
                                                                        <Text fontSize={'13px'} >{badge.badge.name}</Text>
                                                                    </Td>
                                                                    <Td>
                                                                        <Text fontSize={'13px'} >{badge.reason.name}</Text>
                                                                    </Td>
                                                                    <Td>
                                                                        {badge.revoked_at ? <Text textAlign={'center'} fontSize={'13px'} ><BsCheckLg color='green' /></Text> :
                                                                            <Text fontSize={'13px'} ><FaTimes color='red' /></Text>}
                                                                    </Td>

                                                                    <Td>
                                                                        {!badge.revoked_at && <HStack>
                                                                            <Button
                                                                                cursor="pointer"
                                                                                colorScheme='red'
                                                                                variant={'outline'}
                                                                                size={'sm'}
                                                                                fontSize={'13px'}
                                                                                onClick={() => { openRevokeBadge(badge.id.toString()) }}
                                                                            >
                                                                                Revoke
                                                                            </Button>

                                                                        </HStack>}
                                                                    </Td>
                                                                </Tr>
                                                            ))
                                                        )
                                                    }
                                                </Tbody>
                                            </Table>
                                        </TableContainer>


                                    </Box>
                                    {isbadge && (
                                        <Portal>
                                            {" "}
                                            <CreateBadgeModal
                                                isOpenbadgeType={isbadge}
                                                onClosed={setisbadge}
                                                isbadge={isbadge}
                                                reload={reloadData}
                                            />{" "}
                                        </Portal>
                                    )}

                                </Box>
                                <Portal>
                                    <AlertDialog
                                        isOpen={isOpenAlert}
                                        leastDestructiveRef={cancelRef}
                                        onClose={onCloseAlert}
                                    >
                                        <AlertDialogOverlay>
                                            <AlertDialogContent>
                                                <AlertDialogHeader fontSize="md" fontWeight="semibold">
                                                    Revoke Badge
                                                </AlertDialogHeader>

                                                <AlertDialogBody fontSize={15}>
                                                    Are you sure? You can't undo this action afterwards.
                                                </AlertDialogBody>

                                                <AlertDialogFooter>
                                                    <Button size={"sm"} ref={cancelRef} onClick={onCloseAlert}>
                                                        Cancel
                                                    </Button>
                                                    <Button
                                                        size={"sm"}
                                                        colorScheme="red"
                                                        onClick={revokeBadge}
                                                        ml={3}
                                                    >
                                                        Revoke
                                                    </Button>
                                                </AlertDialogFooter>
                                            </AlertDialogContent>
                                        </AlertDialogOverlay>
                                    </AlertDialog>
                                </Portal>
                            </Box>
                        </Box>

                    </Box>
                </Flex>


            }
        </>
    )
}

export default AssignedBadges;